import { Lightbulb } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Stripe-pattern callout — friendly пересказ юридической секции.
 * Применяется в markdown через `:::plain ... :::`.
 * Brand-promise: «честный прагматичный скептик» — без юр-сленга, без воды.
 *
 * P0-1 (протокол №033): дифференциация callout-блоков. Раньше использовался
 * full card (rounded-lg + bg-surface-subtle) — визуально не отличался от
 * TldrPill / CeoIntro. Теперь — inline aside с border-l-2.
 */
export function PlainExplanation({ children }: { children: ReactNode }) {
  return (
    <div className="my-8 flex gap-3 border-l-2 border-action-primary-bg pl-4">
      <Lightbulb className="mt-0.5 h-5 w-5 shrink-0 text-action-primary-bg" aria-hidden />
      <div className="min-w-0 flex-1">
        <span className="mb-1 block text-xs font-semibold uppercase tracking-wider text-text-secondary">
          По-человечески
        </span>
        <div className="text-base leading-relaxed text-text-primary">
          {children}
        </div>
      </div>
    </div>
  );
}
